import React, { Component } from 'react';
import './HappyCall.css';
import base64 from 'base-64';

export default class extends Component {
    componentDidMount(){
      document.title = "안전점검 서비스 고객만족도 조사";
    }
    constructor() {
        super();
        this.state = {
          cust_no: '',
          survey_nm: '',
          effective_date: '',
          selected_q1: '',
          selected_q2: '',
          selected_q3: '',
          selected_q4: '',
          selected_q5: '',
          selected_q6: '',
          selected_q7: '',
          selected_q8: '',
          selected_q9: '',
          selected_q10: '',
          survey_chk: ''
        };
        this.stateRefresh = this.stateRefresh.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
      }
      stateRefresh() {
        this.setState({
            cust_no: '',
            survey_nm: '',
            effective_date: '',
            selected_q1: '',
            selected_q2: '',
            selected_q3: '',
            selected_q4: '',
            selected_q5: '',
            selected_q6: '',
            selected_q7: '',
            selected_q8: '',
            selected_q9: '',
            selected_q10: '',
            survey_chk: ''
        });
      }
      q1Change = event => {
        this.setState({ selected_q1: event.target.value });
      };
      q2Change = event => {
        this.setState({ selected_q2: event.target.value });
      };
      q3Change = event => {
        this.setState({ selected_q3: event.target.value });
      };
      q4Change = event => {
        this.setState({ selected_q4: event.target.value });
      };
      q5Change = event => {
        this.setState({ selected_q5: event.target.value });
      };
      q6Change = event => {
        this.setState({ selected_q6: event.target.value });
      };
      q7Change = event => {
        this.setState({ selected_q7: event.target.value });
      };
      q8Change = event => {
        this.setState({ selected_q8: event.target.value });
      };

      handleFormSubmit(event) {
        event.preventDefault();

        if(this.state.selected_q1 === ""  || this.state.selected_q2 === ""  || this.state.selected_q3 === ""  || this.state.selected_q4 === ""  || this.state.selected_q5 === ""  || this.state.selected_q6 === ""){
          alert("Q1 ~ Q6 항목에 누락된 항목이 있습니다.\n입력 확인 부탁 드립니다.");
          return;
        }

        this.chkSurveyResult();
      }

      chkSurveyResult = async () => {
        const { params } = this.props.match;
        this.setState({ cust_no: base64.decode(params.cust_no) });
        this.setState({ effective_date: (params.effective_date === undefined ? "": base64.decode(params.effective_date)) });
        const cust_no = base64.decode(params.cust_no);
        const survey_nm = "safety";
        const effective_date = (params.effective_date === undefined ? "": base64.decode(params.effective_date));

        const response = await fetch('/api/happy_call_chk', {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type' : 'application/json'
            },
            body: JSON.stringify({
                cust_no: cust_no,
                survey_nm: survey_nm,
                effective_date: effective_date
              })
            })
            
            const body = await response.json();

            body.forEach((dt) => {
                this.setState({ survey_chk: dt.CHK});
            })
            if(this.state.survey_chk > 0){
                alert("설문 참여가 완료된 상태입니다.\n설문응답을 종료합니다.");
            }else{
                this.addSurveyResult();
                alert("설문에 참여해 주셔서 감사합니다.\n설문응답을 종료합니다.");
            }
            return body;
      }

      addSurveyResult = async () => {
        const { params } = this.props.match;
        this.setState({ cust_no: base64.decode(params.cust_no) });
        this.setState({ effective_date: (params.effective_date === undefined ? "": base64.decode(params.effective_date)) });
        const cust_no = base64.decode(params.cust_no);
        const survey_nm = "safety";
        const effective_date = (params.effective_date === undefined ? "": base64.decode(params.effective_date));
        const selected_q1 = this.state.selected_q1;
        const selected_q2 = this.state.selected_q2;
        const selected_q3 = this.state.selected_q3;
        const selected_q4 = this.state.selected_q4; 
        const selected_q5 = this.state.selected_q5;
        const selected_q6 = this.state.selected_q6;
        const selected_q7 = this.state.selected_q7;
        const selected_q8 = this.state.selected_q8;
        const selected_q9 = this.state.selected_q9;
        const selected_q10 = this.state.selected_q10;

        const response = await fetch('/api/happy_call_insert', {
          method: "post",
          headers: {
              'Accept': 'application/json',
              'Content-Type' : 'application/json'
          },
          body: JSON.stringify({
              cust_no: cust_no,
              survey_nm: survey_nm,
              effective_date: effective_date,
              selected_q1: selected_q1,
              selected_q2: selected_q2,
              selected_q3: selected_q3,
              selected_q4: selected_q4,
              selected_q5: selected_q5,
              selected_q6: selected_q6,
              selected_q7: selected_q7,
              selected_q8: selected_q8,
              selected_q9: selected_q9,
              selected_q10: selected_q10
            })
          })
        }
      
    render(){
      const { params } = this.props.match;
      var today = new Date();
      var decode_date = base64.decode(params.effective_date);
      var effective_date = new Date(decode_date.substring(0,4), decode_date.substring(4,6)-1, decode_date.substring(6,8));
      effective_date.setDate(effective_date.getDate()+20);//+20일 까지만 가능
      if(today <= effective_date){        
        return (
          <form onSubmit={this.handleFormSubmit}>
              <div className="body center">
                  <h3 className="h3">○ 해피콜 조사 질문지</h3>
                  <h2 className="h2">[대륜이엔에스] 안전점검 서비스 고객만족도 조사</h2>
                  <p className="p">Q1. 도시가스 정기안전점검 안내 메시지를 점검예정일 이전에 받아보셨나요?</p>
                  <div className="form">
                      <input type="radio" name="q1" value="Y" checked={this.state.selected_q1 === "Y"} onChange={this.q1Change}/> 예
                      <br></br>
                      <input type="radio" name="q1" value="N" checked={this.state.selected_q1 === "N"} onChange={this.q1Change}/> 아니오
                  </div>
                  <p className="p">Q2. 방문드린 안전점검원의 성별은 무엇인가요?</p>
                  <div className="form">
                      <input type="radio" name="q2" value="F" checked={this.state.selected_q2 === "F"} onChange={this.q2Change}/> 여자
                      <br></br>
                      <input type="radio" name="q2" value="M" checked={this.state.selected_q2 === "M"} onChange={this.q2Change}/> 남자
                  </div>
                  <p className="p">Q3. 방문드린 안전점검원이 약속드린 일정에 맞춰 방문하였나요?</p>
                  <div className="form">
                      <input type="radio" name="q3" value="Y" checked={this.state.selected_q3 === "Y"} onChange={this.q3Change}/> 예 (일정에 맞춰 도착)
                      <br></br>
                      <input type="radio" name="q3" value="N" checked={this.state.selected_q3 === "N"} onChange={this.q3Change}/> 아니오 (일정보다 늦게 도착)
                  </div>
                  <p className="p">Q4. 방문드린 안전점검원은 유니폼과 명찰을 착용하고 있었나요?</p>
                  <div className="form">
                      <input type="radio" name="q4" value="Y" checked={this.state.selected_q4 === "Y"} onChange={this.q4Change}/> 예
                      <br></br>
                      <input type="radio" name="q4" value="N" checked={this.state.selected_q4 === "N"} onChange={this.q4Change}/> 아니오
                  </div>
                  <p className="p">Q5. 방문드린 안전점검원이 점검 후 점검결과에 대해 알기 쉽게 설명해 주었나요?</p>
                  <div className="form">
                      <input type="radio" name="q5" value="3" checked={this.state.selected_q5 === "3"} onChange={this.q5Change}/> 그렇다
                      <br></br>
                      <input type="radio" name="q5" value="2" checked={this.state.selected_q5 === "2"} onChange={this.q5Change}/> 보통이다
                      <br></br>
                      <input type="radio" name="q5" value="1" checked={this.state.selected_q5 === "1"} onChange={this.q5Change}/> 전혀 그렇지 않다
                  </div>
                  <p className="p">Q6. 방문드린 안전점검원의 전반적인 고객응대태도는 어떻게 느끼셨나요?</p>
                  <div className="form">
                      <input type="radio" name="q6" value="5" checked={this.state.selected_q6 === "5"} onChange={this.q6Change}/> 매우만족
                      <br></br>
                      <input type="radio" name="q6" value="4" checked={this.state.selected_q6 === "4"} onChange={this.q6Change}/> 만족
                      <br></br>
                      <input type="radio" name="q6" value="3" checked={this.state.selected_q6 === "3"} onChange={this.q6Change}/> 보통
                      <br></br>
                      <input type="radio" name="q6" value="2" checked={this.state.selected_q6 === "2"} onChange={this.q6Change}/> 미흡
                      <br></br>
                      <input type="radio" name="q6" value="1" checked={this.state.selected_q6 === "1"} onChange={this.q6Change}/> 불만족
                  </div>
                  <p className="p">Q7. 마지막으로 도시가스를 이용하시면서 불편하신점이나 개선할 부분이 있으시면 말씀해 주시겠습니까?</p>
                  <div className="t_form">
                      <textarea name="q7" placeholder="빈칸을 입력하여 주세요.(선택)" onChange={this.q7Change}></textarea>
                  </div>
                  <div className="c">
                  <button className="button" type="submit">제출</button>
                  </div>
              </div>
          </form>
        )
      }else{
        return(
          <div>
            <h3 className="h3">&nbsp;기간이 만료되었습니다.</h3>
            <p>&nbsp;평가기간 : {effective_date.getFullYear()}/{effective_date.getMonth()+1}/{effective_date.getDate()} 까지</p>
          </div>
        );
      }
    }
};